import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ComponentsModule } from '@freelancer/components';
import { TrackingModule } from '@freelancer/tracking';
import { UiModule } from '@freelancer/ui';
import { ConfirmDeleteFileModalComponent } from './confirm-delete-file-modal.component';

@NgModule({
  imports: [CommonModule, ComponentsModule, TrackingModule, UiModule],
  declarations: [ConfirmDeleteFileModalComponent],
})
export class ConfirmDeleteFileModalModule {}
